(function () {
    'use strict';

    angular.module('app').directive('fodbzDropdownRequired', ComboboxDirective);

    ComboboxDirective.$inject = [];
    function ComboboxDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                organisationTypes: '=',
                fodbzDisabled: '=',
                fodbzInit: '@'
            },
            template: `
            <select aria-describedby="{{fodbzFieldConst}}Error"
                    class="form-control"
                    ng-required="true"
                    ng-model="fodbzModel"
                    ng-disabled="fodbzDisabled"
                    id="{{fodbzFieldConst}}"
                    name="{{fodbzFieldConst}}"
                    ng-options="item.Key as item.Value for item in organisationTypes"
                    type="number" required="required">
                    <option ng-if="fodbzInit" value="" class="combo-placeholder">{{fodbzInit}}</option>
            </select>`,
        };
    }

})();